const initialState = {
    loaded: false,
};

export default function documentState(state = initialState, action) {
    switch (action.type) {
        case 'DOCUMENT_LOADED':
            return {
                ...state,
                loaded: true,
            };
        default:
            return state;
    }
}
